import { Box, Transition } from '@wix/design-system';
import React, { FC } from 'react';
import { useSelector, useStore } from 'react-redux';

import { logChatbotGeneralClientLog } from '../../../bi/loggers/logChatbotGeneralClientLog';
import { useIsAiChatbot } from '../../../common/hooks/useIsAiChatbot';
import { selectItems } from '../../../common/selectors/chat';
import { experiments } from '../../../experiments';
import s from './styles.scss';

const updatedUIForPartners = experiments.is('specs.chatbot.AiChatbotPartners', 'true');
const greetingForDiyEnabled = experiments.is('specs.chatbot.newRootNodeForDiy', 'true');

/**
 * Abstract UserGreeting container for positioning some greeting message when conversation is empty.
 */
export const UserGreeting: FC = ({ children }) => {
  const items = useSelector(selectItems);
  const isAiChatbot = useIsAiChatbot();
  const shouldShowGreeting =
    isAiChatbot && (updatedUIForPartners || greetingForDiyEnabled) && items.length === 0;
  const store = useStore();

  if (shouldShowGreeting) {
    logChatbotGeneralClientLog(store.getState(), { message: 'Render UserGreeting', data: {} }); // Log for debugging purposes;
  }

  return (
    <Transition
      show={shouldShowGreeting}
      exitAnimation={{
        moveOut: {
          direction: 'bottomToTop',
          distance: '72px',
          duration: 'fast02',
          easing: 'exitEasing',
        },
        fadeOut: {
          duration: 'fast02',
          easing: 'exitEasing',
        },
      }}
    >
      <Box position="relative" className={s.fadeIn}>
        <Box position="absolute" top="0" left="0" right="0">
          {children}
        </Box>
      </Box>
    </Transition>
  );
};
